import { all, fork, takeEvery, put } from "redux-saga/effects";
import { slotsApi } from '../../api/index';
import { SlotsActionTypes,SignalRTypes } from '../actions';
import { SessionStorage, Cookies } from "../../helpers";
import { JackpotLevel } from '../../helpers/enums';

export function* requests() {
    yield takeEvery(SlotsActionTypes.Get_Jackpot_Request, function* () {
        //call server
        try {
            let response = yield slotsApi.getJackpots();

            if (response.status === 1) {
                var result = response.data && response.data.reduce(function (map, obj) {
                    map[obj.jackpotLevelId] = obj;
                    return map;
                }, {});

                let winningMessage = null;
                let jackpotId = null;
                let winnerJackpotId = null;
                let singleGameWinningMessage = null;
                let singleGameJackpotId = null;
                let singleGameWinnerJackpotId = null;
                if (result && result[JackpotLevel.Web]) {
                    const item = result[JackpotLevel.Web];
                    if (item.isWon) {
                        const token = Cookies.get("token");
                        winningMessage = (item.winningToken && item.winningToken == token) ? item.winningMemberMessage : item.winningGeneralMessage;
                        winnerJackpotId = item.jackpotId;    
                    }
                    jackpotId = item.jackpotId

                }
                if (result && result[JackpotLevel.SingleGame]) {
                    const item = result[JackpotLevel.SingleGame];
                    if (item.isWon) {
                        const token = Cookies.get("token");
                        singleGameWinningMessage = (item.winningToken && item.winningToken == token) ? item.winningMemberMessage : item.winningGeneralMessage;
                        singleGameJackpotId = item.jackpotId;    
                    }
                    singleGameWinnerJackpotId = item.jackpotId

                }
                yield put({ type: SlotsActionTypes.Get_Jackpot_Success, jackpotBalances: result, winningMessage: winningMessage, 
                    jackpotId: jackpotId, winnerJackpotId: winnerJackpotId , singleGameWinningMessage: singleGameWinningMessage,  singleGameJackpotId:singleGameJackpotId , singleGameWinnerJackpotId: singleGameWinnerJackpotId})
            }
            else {
                if (response.message) {
                    yield put({ type: SlotsActionTypes.Get_Jackpot_Error, message: response.message })
                }
            }
        }

        catch (error) {
            window.log('client ==>> could not get jackpot');
        }
    })

}
export default function* JackpotSaga() {
    yield all([
        fork(requests)
    ])
}